{
	"label": "MSES screens",
	"sections": {
		"overview": "Overview",
		"medals": "Medals"
	},
	"items": {
		"dashboard": "Dashboard",
		"award": "Award medals",
		"tally": "Medal tally"
	},
	"short": {
		"dashboard": "Home",
		"award": "Award",
		"tally": "Tally"
	},
	"sidebar": {
		"home": "Go to the dashboard",
		"brandTitle": "SEA Games 2027",
		"brandSubtitle": "Medal desk",
		"collapse": "Collapse sidebar",
		"expand": "Expand sidebar",
		"openMenu": "Open menu",
		"closeMenu": "Close menu"
	},
	"counts": {
		"pending_one": "{{count}} event to award",
		"pending_other": "{{count}} events to award",
		"changed_one": "{{count}} awarded event changed since",
		"changed_other": "{{count}} awarded events changed since",
		"awarded_one": "{{count}} event awarded",
		"awarded_other": "{{count}} events awarded"
	},
	"games": {
		"loading": "Loading games…",
		"loadError": "Games could not load",
		"none": "No games yet",
		"current": "Current games: {{name}}",
		"menuLabel": "Games",
		"para": "Para",
		"switchTo": "Switch to {{name}}",
		"switchGames": "Switch games"
	},
	"profile": {
		"menu": "Account menu for {{name}}",
		"activeRole": "Active role",
		"switchRole": "Switch role"
	}
}
